import i18n from 'i18next';
import LngDetector from 'i18next-browser-languagedetector';
import formatter from 'common/i18n/formatter';
import { pruneLanguage, setLanguageForLib } from 'common/i18n/i18n';
import translations from './translations';

i18n
  .use(LngDetector)
  .init({
    fallbackLng: 'en',
    debug: false,

    resources: translations,

    defaultNS: 'general',
    fallbackNS: 'common',

    interpolation: {
      escapeValue: false, // not needed for react
      format: formatter,
    },

    react: {
      defaultTransParent: 'span',
    },

    detection: {
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],

      lookupQuerystring: 'lang',
      lookupLocalStorage: 'lang',

      caches: ['localStorage'],
      excludeCacheFor: ['cimode'],
    },
  });

const language = pruneLanguage(i18n.language);

i18n.changeLanguage(language, () => {
  setLanguageForLib(language);
  i18n.on('languageChanged', setLanguageForLib);
});

export default i18n;



// WEBPACK FOOTER //
// ./src/statsradio/i18n/i18n.js